import {
  type ResourceFilter,
  toResourceFilter,
} from "../domains/TimelineResourceFilter";
import { usePushHistory } from "./usePushHistory";
import { useQueryString } from "./useQueryString";

// フィルタ条件を URL クエリパラメータで保持するキー。
// この状態が「叩く API の選択」「生徒一覧 API へのフィルタ受け渡し」を駆動する（消費側 WEB-1713/1715）。
// タブ切替をまたいだ保持（FILTER-05）は WEB-1718 が本フックを利用して実現する。
export const RESOURCE_FILTER_QUERY_KEY = "resource_filter";

type ResourceFilterQuery = {
  [RESOURCE_FILTER_QUERY_KEY]: ResourceFilter;
};

// AI質問タイムラインのフィルタ状態（URL クエリパラメータの読み書き）。
export const useTimelineResourceFilter = () => {
  const queryParams = useQueryString();
  const { pushHistory } = usePushHistory<ResourceFilterQuery>();

  // 未指定・未知値は初期値（すべて）にフォールバック
  const filter = toResourceFilter(queryParams[RESOURCE_FILTER_QUERY_KEY]);

  // options は usePushHistory のオプション（replace やページネーション解除の deleteKeys 等）を素通しする。
  // 消費側（WEB-1713/1715/1718）がフィルタ変更時に併発操作を指定できるようにするため。
  const setFilter = (
    next: ResourceFilter,
    options?: Parameters<typeof pushHistory>[1],
  ) => {
    pushHistory({ [RESOURCE_FILTER_QUERY_KEY]: next }, options);
  };

  return { filter, setFilter };
};
